/**
 * Locale date formatter that is correct for both DATE and timestamp
 * values (assessment U4 date-only bug).
 *
 * DATE columns arrive over the wire as `YYYY-MM-DD` with no time or
 * zone. Parsing those with a bare `new Date("2026-07-06")` anchors
 * them at UTC midnight, which `toLocaleDateString` then rolls back a
 * day for any viewer west of UTC. Anchoring date-only values at UTC
 * noon avoids the shift (the approach `project-plan.tsx` already used).
 *
 * Full timestamps already carry a time + offset, so they parse as-is —
 * appending a time to them would corrupt the string. We branch on the
 * shape.
 */
export function formatDate(value: string): string {
  const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(value);
  const date = isDateOnly ? new Date(`${value}T12:00:00Z`) : new Date(value);
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}
